import { type SelectChangeEvent } from '@mui/material';

export const isValueTrueString = (
  value: SelectChangeEvent<unknown>['target']['value'],
): value is string => {
  return !!value && typeof value === 'string';
};
